import Immutable from "immutable";
import config from "#config";

import {
  USER_SIGNED_OUT,
  FETCH_USER_PROFILE,
  USER_SIGNED_IN,
} from "../constants/action-types";

export const AuthenticationState = Immutable.Record(
  {
    domain: null,
    clientID: null,
    userId: null,
    username: null,
    isLoggedIn: false,
  },
  "AuthenticationState"
);

const persistedState = () => {
  const domain = config.DOMAIN;
  const clientId = config.CLIENT_ID;
  const userId = localStorage.getItem("user_id");
  const username = localStorage.getItem("user_trait");
  const isLoggedIn = !!(userId && username);

  return new AuthenticationState({
    // @ts-expect-error legacy opshub typing
    domain,
    // @ts-expect-error legacy opshub typing
    clientID: clientId,
    // @ts-expect-error legacy opshub typing
    userId,
    // @ts-expect-error legacy opshub typing
    username,
    isLoggedIn,
  });
};

export default (state = persistedState(), action) => {
  switch (action.type) {
    case FETCH_USER_PROFILE: {
      const userId = action.payload.id;
      const username = action.payload.name;

      localStorage.setItem("user_id", userId);
      localStorage.setItem("user_trait", username);

      return state.merge({ userId, username });
    }
    case USER_SIGNED_IN:
      return state.set("isLoggedIn", true);
    case USER_SIGNED_OUT:
      localStorage.removeItem("user_trait");
      localStorage.removeItem("user_id");

      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isLoggedIn = false;
        // @ts-expect-error legacy opshub typing
        s.username = undefined;
        // @ts-expect-error legacy opshub typing
        s.userId = undefined;
      });
    default:
      return state;
  }
};
